import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { IconComponent } from '../../../../shared/icon/icon.component';
import type { Location } from '../../../locations/location.model';

export type LocationAvatarSize = 'sm' | 'md';

interface AvatarDimensions {
  readonly px: number;
  readonly iconPx: number;
  readonly box: string;
  readonly icon: string;
}

const SIZES = {
  sm: { px: 20, iconPx: 12, box: 'size-5', icon: 'size-3' },
  md: { px: 32, iconPx: 16, box: 'size-8', icon: 'size-4' },
} as const satisfies Record<LocationAvatarSize, AvatarDimensions>;

/**
 * Round location avatar. Falls back to the photo placeholder used in LocationItem;
 * `location === null` renders the "All locations" badge.
 */
@Component({
  selector: 'app-location-avatar',
  imports: [NgOptimizedImage, IconComponent],
  templateUrl: './location-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0' },
})
export class LocationAvatarComponent {
  readonly location = input.required<Pick<Location, 'avatarThumbnailUrl'> | null>();
  readonly size = input<LocationAvatarSize>('md');

  protected readonly dimensions = computed<AvatarDimensions>(() => SIZES[this.size()]);
}
